(() => {
  if (window.VidaRoiCartFeedback) return;

  const rootUrl = () => window.Shopify?.routes?.root || '/';
  let hideTimer;
  let currentAddition = null;

  const snackbar = () => document.querySelector('[data-vr-cart-snackbar]');
  const updateCartCount = (cart) => {
    if (!cart) return;
    document.querySelectorAll('.vr-cart-button span, .vr-action__count').forEach((counter) => {
      counter.textContent = cart.item_count;
    });
    document.querySelectorAll('.vr-cart-button').forEach((link) => {
      link.setAttribute('aria-label', `Coș, ${cart.item_count} produse`);
    });
  };

  const hide = () => {
    window.clearTimeout(hideTimer);
    const panel = snackbar();
    if (!panel) return;
    panel.classList.remove('is-visible', 'is-error', 'is-busy');
    panel.setAttribute('aria-hidden', 'true');
    currentAddition = null;
  };

  const scheduleHide = () => {
    window.clearTimeout(hideTimer);
    hideTimer = window.setTimeout(hide, 7000);
  };

  const show = ({ item, quantity = 1, title = '' }) => {
    const panel = snackbar();
    if (!panel) return;
    const addedQuantity = Math.max(1, Number(quantity) || 1);
    currentAddition = { key: item?.key || item?.id, quantity: addedQuantity };
    panel.querySelector('[data-vr-cart-snackbar-title]').textContent = 'Produs adăugat în coș';
    panel.querySelector('[data-vr-cart-snackbar-product]').textContent = item?.product_title || item?.title || title || 'Produsul ales';
    const undo = panel.querySelector('[data-vr-cart-snackbar-undo]');
    undo.disabled = false;
    undo.textContent = 'Anulează';
    panel.classList.remove('is-error', 'is-busy');
    panel.classList.add('is-visible');
    panel.setAttribute('aria-hidden', 'false');
    scheduleHide();
  };

  const refreshCount = async () => {
    const response = await fetch(`${rootUrl()}cart.js`, { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Cart request failed');
    const cart = await response.json();
    updateCartCount(cart);
    return cart;
  };

  const undo = async () => {
    const panel = snackbar();
    const addition = currentAddition;
    if (!panel || !addition || panel.classList.contains('is-busy')) return;
    const button = panel.querySelector('[data-vr-cart-snackbar-undo]');
    panel.classList.add('is-busy');
    button.disabled = true;
    button.textContent = 'Se anulează…';
    window.clearTimeout(hideTimer);
    try {
      const cart = await refreshCount();
      const line = cart.items.find((item) => item.key === addition.key || String(item.id) === String(addition.key));
      if (line) {
        const response = await fetch(`${rootUrl()}cart/change.js`, {
          method: 'POST',
          headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: line.key, quantity: Math.max(0, line.quantity - addition.quantity) }),
        });
        if (!response.ok) throw new Error('Undo request failed');
        updateCartCount(await response.json());
      }
      hide();
    } catch (error) {
      panel.classList.remove('is-busy');
      panel.classList.add('is-error');
      panel.querySelector('[data-vr-cart-snackbar-title]').textContent = 'Nu am putut anula adăugarea';
      panel.querySelector('[data-vr-cart-snackbar-product]').textContent = 'Poți modifica produsul direct din coș.';
      button.disabled = false;
      button.textContent = 'Încearcă din nou';
      scheduleHide();
    }
  };

  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-vr-cart-snackbar-undo]')) undo();
  });
  document.addEventListener('mouseenter', (event) => {
    if (event.target.closest?.('[data-vr-cart-snackbar]')) window.clearTimeout(hideTimer);
  }, true);
  document.addEventListener('mouseleave', (event) => {
    if (event.target.closest?.('[data-vr-cart-snackbar]')) scheduleHide();
  }, true);

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest?.('[data-vr-product-form]');
    if (!form || form.dataset.vrCartSubmitting === 'true') return;
    event.preventDefault();
    const button = form.querySelector('[name="add"]');
    if (!button || button.disabled) return;
    form.dataset.vrCartSubmitting = 'true';
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    const quantity = Number(form.querySelector('[name="quantity"]')?.value || 1);
    try {
      const response = await fetch(`${rootUrl()}cart/add.js`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form),
      });
      if (!response.ok) throw new Error('Add to cart failed');
      const item = await response.json();
      await refreshCount();
      button.classList.add('is-added');
      window.setTimeout(() => button.classList.remove('is-added'), 1400);
      show({ item, quantity, title: button.getAttribute('aria-label') || '' });
    } catch (error) {
      HTMLFormElement.prototype.submit.call(form);
    } finally {
      delete form.dataset.vrCartSubmitting;
      button.removeAttribute('aria-busy');
      button.disabled = false;
    }
  });

  window.VidaRoiCartFeedback = { show, hide, refreshCount, updateCartCount };
})();

(() => {
  const initialise = (root) => {
    if (root.dataset.vrHeaderReady === 'true') return;
    root.dataset.vrHeaderReady = 'true';

    const openButton = root.querySelector('.vr-menu-button');
    const drawer = root.querySelector('.vr-mobile-menu:not(.vr-mobile-menu--legacy)');
    const closeButton = drawer?.querySelector('.vr-mobile-menu__close');
    const mainHeader = root.querySelector('.vr-main-header');
    const candleDropdown = root.querySelector('[data-vr-candle-dropdown]');
    const searchTrigger = root.querySelector('[data-vr-search-trigger]');
    const searchPanel = root.querySelector('[data-vr-search-panel]');
    const searchClose = root.querySelector('[data-vr-search-close]');
    const searchForm = root.querySelector('[data-vr-search-form]');
    const searchInput = root.querySelector('[data-vr-search-input]');
    const searchStatus = root.querySelector('[data-vr-search-status]');
    const searchResults = root.querySelector('[data-vr-search-results]');
    const searchAll = root.querySelector('[data-vr-search-all]');
    const searchSuggestions = root.querySelector('[data-vr-search-suggestions]');
    const accountTrigger = root.querySelector('[data-vr-account-trigger]');
    const accountPanel = root.querySelector('[data-vr-account-panel]');
    const accountClose = root.querySelector('[data-vr-account-close]');

    const setPopoverOpen = (trigger, panel, isOpen) => {
      if (!trigger || !panel) return;
      panel.classList.toggle('is-open', isOpen);
      panel.setAttribute('aria-hidden', String(!isOpen));
      trigger.setAttribute('aria-expanded', String(isOpen));
    };

    const closeHeaderPopovers = (except = null) => {
      if (except !== searchPanel) setPopoverOpen(searchTrigger, searchPanel, false);
      if (except !== accountPanel) setPopoverOpen(accountTrigger, accountPanel, false);
    };

    if (searchTrigger && searchPanel && searchInput && searchResults && searchStatus) {
      let debounceTimer;
      let requestController;

      const setSuggestionsVisible = (isVisible) => {
        if (!searchSuggestions) return;
        searchSuggestions.classList.toggle('is-visible', isVisible);
        searchSuggestions.setAttribute('aria-hidden', String(!isVisible));
      };

      const formatPrice = (value) => {
        const number = Number.parseFloat(String(value ?? '').replace(',', '.'));
        if (!Number.isFinite(number)) return '';
        return new Intl.NumberFormat('ro-RO', { style: 'currency', currency: 'RON', maximumFractionDigits: 2 }).format(number);
      };

      const emptyMedia = () => {
        const media = document.createElement('span');
        media.className = 'vr-search-result__media vr-search-result__media--empty';
        media.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 4h6v16H9zM10 4c0-1.4.7-2.4 2-3 .8.9 1.2 1.9 1 3"/></svg>';
        return media;
      };

      const renderProducts = (products, query) => {
        searchResults.replaceChildren();
        if (!products.length) {
          searchStatus.textContent = `Nu am găsit produse pentru „${query}”.`;
          searchAll.hidden = true;
          setSuggestionsVisible(true);
          return;
        }

        const fragment = document.createDocumentFragment();
        products.forEach((product) => {
          const link = document.createElement('a');
          link.className = 'vr-search-result';
          link.href = product.url;

          const imageUrl = typeof product.image === 'string'
            ? product.image
            : product.image?.url || product.featured_image?.url || product.featured_image;
          if (imageUrl) {
            const media = document.createElement('span');
            media.className = 'vr-search-result__media';
            const image = document.createElement('img');
            image.src = imageUrl;
            image.alt = '';
            image.loading = 'lazy';
            media.append(image);
            link.append(media);
          } else {
            link.append(emptyMedia());
          }

          const copy = document.createElement('span');
          const title = document.createElement('strong');
          title.className = 'vr-search-result__title';
          title.textContent = product.title;
          copy.append(title);
          if (product.type) {
            const type = document.createElement('small');
            type.className = 'vr-search-result__type';
            type.textContent = product.type;
            copy.append(type);
          }
          link.append(copy);

          const priceText = formatPrice(product.price);
          if (priceText) {
            const price = document.createElement('span');
            price.className = 'vr-search-result__price';
            price.textContent = priceText;
            link.append(price);
          }
          fragment.append(link);
        });
        searchResults.append(fragment);
        searchStatus.textContent = `${products.length} ${products.length === 1 ? 'produs găsit' : 'produse găsite'}.`;
        searchAll.href = `${searchForm.action}?q=${encodeURIComponent(query)}&type=product`;
        searchAll.hidden = false;
        setSuggestionsVisible(true);
      };

      const runSearch = async () => {
        const query = searchInput.value.trim();
        window.clearTimeout(debounceTimer);
        requestController?.abort();
        if (query.length < 2) {
          searchResults.replaceChildren();
          searchStatus.textContent = 'Introdu cel puțin două caractere.';
          searchStatus.classList.remove('is-loading');
          searchAll.hidden = true;
          setSuggestionsVisible(false);
          return;
        }

        requestController = new AbortController();
        searchStatus.textContent = 'Căutăm produsele';
        searchStatus.classList.add('is-loading');
        searchAll.hidden = true;
        setSuggestionsVisible(true);
        const endpoint = searchPanel.dataset.vrSearchEndpoint || '/search/suggest.json';
        const params = new URLSearchParams({
          q: query,
          'resources[type]': 'product',
          'resources[limit]': '5',
          'resources[options][unavailable_products]': 'hide',
        });

        try {
          const response = await fetch(`${endpoint}?${params}`, { signal: requestController.signal, headers: { Accept: 'application/json' } });
          if (!response.ok) throw new Error(`Search request failed: ${response.status}`);
          const payload = await response.json();
          renderProducts(payload.resources?.results?.products || [], query);
        } catch (error) {
          if (error.name === 'AbortError') return;
          searchResults.replaceChildren();
          searchStatus.textContent = 'Căutarea nu este disponibilă momentan. Încearcă din nou.';
          searchAll.hidden = true;
          setSuggestionsVisible(true);
        } finally {
          searchStatus.classList.remove('is-loading');
        }
      };

      const openSearch = () => {
        closeHeaderPopovers(searchPanel);
        setSuggestionsVisible(false);
        setPopoverOpen(searchTrigger, searchPanel, true);
        window.setTimeout(() => searchInput.focus(), 40);
      };

      searchTrigger.addEventListener('click', () => {
        const shouldOpen = !searchPanel.classList.contains('is-open');
        if (shouldOpen) openSearch();
        else setPopoverOpen(searchTrigger, searchPanel, false);
      });
      searchClose?.addEventListener('click', () => {
        setSuggestionsVisible(false);
        setPopoverOpen(searchTrigger, searchPanel, false);
        searchTrigger.focus();
      });
      searchInput.addEventListener('input', () => {
        window.clearTimeout(debounceTimer);
        debounceTimer = window.setTimeout(runSearch, 180);
      });
      searchForm?.addEventListener('submit', (event) => {
        event.preventDefault();
        runSearch();
      });
    }

    if (accountTrigger && accountPanel) {
      accountTrigger.addEventListener('click', () => {
        const shouldOpen = !accountPanel.classList.contains('is-open');
        closeHeaderPopovers(shouldOpen ? accountPanel : null);
        setPopoverOpen(accountTrigger, accountPanel, shouldOpen);
      });
      accountClose?.addEventListener('click', () => {
        setPopoverOpen(accountTrigger, accountPanel, false);
        accountTrigger.focus();
      });
    }

    if (candleDropdown) {
      const trigger = candleDropdown.querySelector('.vr-nav-new__trigger');
      const previewLinks = [...candleDropdown.querySelectorAll('[data-vr-menu-preview]')];
      const previewImages = [...candleDropdown.querySelectorAll('[data-vr-menu-image]')];
      let closeTimer;

      const setDropdownOpen = (isOpen) => {
        window.clearTimeout(closeTimer);
        candleDropdown.classList.toggle('is-open', isOpen);
        trigger?.setAttribute('aria-expanded', String(isOpen));
      };

      const activatePreview = (key) => {
        previewLinks.forEach((link) => link.classList.toggle('is-active', link.dataset.vrMenuPreview === key));
        previewImages.forEach((image) => image.classList.toggle('is-active', image.dataset.vrMenuImage === key));
      };

      if (trigger && !trigger.matches('a[href]')) {
        trigger.addEventListener('click', () => {
          closeHeaderPopovers();
          setDropdownOpen(!candleDropdown.classList.contains('is-open'));
        });
      }
      candleDropdown.addEventListener('mouseenter', () => {
        closeHeaderPopovers();
        setDropdownOpen(true);
      });
      candleDropdown.addEventListener('mouseleave', () => {
        closeTimer = window.setTimeout(() => setDropdownOpen(false), 120);
      });
      candleDropdown.addEventListener('focusin', () => setDropdownOpen(true));
      candleDropdown.addEventListener('focusout', () => {
        closeTimer = window.setTimeout(() => {
          if (!candleDropdown.contains(document.activeElement)) setDropdownOpen(false);
        }, 0);
      });
      previewLinks.forEach((link) => {
        link.addEventListener('mouseenter', () => activatePreview(link.dataset.vrMenuPreview));
        link.addEventListener('focus', () => activatePreview(link.dataset.vrMenuPreview));
      });
      document.addEventListener('click', (event) => {
        if (!candleDropdown.contains(event.target)) setDropdownOpen(false);
      });
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && candleDropdown.classList.contains('is-open')) {
          setDropdownOpen(false);
          trigger?.focus();
        }
      });
    }

    document.addEventListener('click', (event) => {
      const target = event.target;
      if (searchPanel && searchTrigger && !searchPanel.contains(target) && !searchTrigger.contains(target)) setPopoverOpen(searchTrigger, searchPanel, false);
      if (accountPanel && accountTrigger && !accountPanel.contains(target) && !accountTrigger.contains(target)) setPopoverOpen(accountTrigger, accountPanel, false);
    });
    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      const hadOpenPopover = searchPanel?.classList.contains('is-open') || accountPanel?.classList.contains('is-open');
      closeHeaderPopovers();
      if (hadOpenPopover) (searchTrigger || accountTrigger)?.focus();
    });

    if (mainHeader) {
      let ticking = false;
      const updateHeader = () => {
        const isScrolled = window.scrollY > 24;
        mainHeader.classList.toggle('is-compact', isScrolled);
        root.classList.toggle('is-scrolled', isScrolled);
        ticking = false;
      };

      updateHeader();
      window.addEventListener('scroll', () => {
        if (!ticking) {
          window.requestAnimationFrame(updateHeader);
          ticking = true;
        }
      }, { passive: true });
      window.addEventListener('resize', updateHeader, { passive: true });
    }

    if (!openButton || !closeButton || !drawer) return;

    const setOpen = (isOpen) => {
      drawer.classList.toggle('is-open', isOpen);
      drawer.setAttribute('aria-hidden', String(!isOpen));
      openButton.setAttribute('aria-expanded', String(isOpen));
      document.documentElement.classList.toggle('vr-menu-open', isOpen);
    };

    openButton.addEventListener('click', () => setOpen(true));
    closeButton.addEventListener('click', () => setOpen(false));
    drawer.addEventListener('click', (event) => {
      if (event.target === drawer) setOpen(false);
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') setOpen(false);
    });
  };

  document.querySelectorAll('[data-vr-header]').forEach(initialise);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-vr-header]').forEach(initialise);
  });
})();
